export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";

export const DELETE_ADDRESS_REQUEST = "DELETE_ADDRESS_REQUEST";
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";
export const DELETE_ADDRESS_FAILURE = "DELETE_ADDRESS_FAILURE";

export const FETCH_PROFILE_DETAILS = "FETCH_PROFILE_DETAILS";
export const FETCH_PROFILE_DETAILS_SUCCESS = "FETCH_PROFILE_DETAILS_SUCCESS";
export const FETCH_PROFILE_DETAILS_FAILURE = "FETCH_PROFILE_DETAILS_FAILURE";

export const FETCH_ACCESS_CARD = "FETCH_ACCESS_CARD";
export const FETCH_ACCESS_CARD_SUCCESS = "FETCH_ACCESS_CARD_SUCCESS";
export const FETCH_ACCESS_CARD_FAILURE = "FETCH_ACCESS_CARD_FAILURE";

export const FETCH_ORG_ALBUMS = "FETCH_ORG_ALBUMS";
export const FETCH_ORG_ALBUMS_SUCCESS = "FETCH_ORG_ALBUMS_SUCCESS";
export const FETCH_ORG_ALBUMS_FAILURE = "FETCH_ORG_ALBUMS_FAILURE";

export const FETCH_CART = "FETCH_CART";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_FAILURE = "FETCH_CART_FAILURE";

export const POST_CART = "POST_CART";
export const POST_CART_SUCCESS = "POST_CART_SUCCESS";
export const POST_CART_FAILURE = "POST_CART_FAILURE";

export const FETCH_HOME_DATA = "FETCH_HOME_DATA";
export const FETCH_HOME_DATA_SUCCESS = "FETCH_HOME_DATA_SUCCESS";
export const FETCH_HOME_DATA_FAILURE = "FETCH_HOME_DATA_FAILURE";

export const REMOVE_ACCESS_CARD_REQUEST = "DELETE_ACCESS_CARD_REQUEST";
export const REMOVE_ACCESS_CARD_SUCCESS = "DELETE_ACCESS_CARD_SUCCESS";
export const REMOVE_ACCESS_CARD_FAILURE = "DELETE_ACCESS_CARD_FAILURE";

export const REMOVE_ACCESS_CARDS_BULK_REQUEST = "REMOVE_ACCESS_CARDS_BULK_REQUEST";
export const REMOVE_ACCESS_CARDS_BULK_SUCCESS = "REMOVE_ACCESS_CARDS_BULK_SUCCESS";
export const REMOVE_ACCESS_CARDS_BULK_FAILURE = "REMOVE_ACCESS_CARDS_BULK_FAILURE";
export const CLEAR_REMOVAL_BLOCKED_ACCESS_IDS = "CLEAR_REMOVAL_BLOCKED_ACCESS_IDS";




import {
  UPDATE_KIDS_NAME,
  POST_EVENT_ORDER_META_UPDATE_REQ,
  GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ,
  GET_PRODUCTS_DATA_FOR_EVENT_REQ,
  SET_CURRENT_ACCESS_CARD_STATE,
  CLEAR_PRODUCTS,
  GET_CUSTOMER_OFFERS_REQ,
  GET_ADDRESS_DATA_REQ,
  POST_NEW_ADDRESS_REQ,
  PO_INIT_REQ,
  UPDATE_ORG_ID_FOR_ACCESS_CARD,
  UPDATE_CHECKOUT_STEPS_DATA,
  UPDATE_SELECTED_CUSTOMER_ADDRESS,
  CLEAR_EXISTING_PO,
  UPDATE_BILLING_ADDRESS_FLAG,
  FETCH_PAYBOX_DATA,
  CHOOSE_OFFER_TO_APPLY,
  // REMOVE_OFFER_TO_APPLY,
  APPLY_OFFER_TO_CART_REQ,
  GET_PAYMENT_RESULT,
  GET_PAYMENT_RESULT_SUCCESS,
  GET_PAYMENT_RESULT_FAILURE,
  // APPLY_OFFER_TO_CART_SUCCESS,
  // APPLY_OFFER_TO_CART_FAILURE
  GET_CUSTOMER_PURCHASE_ORDERS_REQ,
  GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS,
  GET_CUSTOMER_PURCHASE_ORDERS_FAILURE,
  DOWNLOAD_HD_IN_ORDER,
  DOWNLOAD_HD_IN_ORDER_SUCCESS,
  DOWNLOAD_HD_IN_ORDER_FAILURE,
  SET_CHECKOUT_REFFERER,
  CLEAR_CHECKOUT_REFFERER,
  SET_CASH_PAYMENT_DETAILS,
  CLEAR_KIDS_NAMES,
  SET_RESET_PASSWORD_DATA,
  GET_OTP_FOR_ACCESS_CARD,
  VERIFY_ACCESS_CARD_OTP,
  SET_OTP_VERIFIED_STATUS,
  POST_PO_ADDRESS_REQ,
  GET_PO_ADDRESS_REQ,
  SET_SHIPPING_SAME_AS_BILLING
} from "./constants";

// Action creators
export const changeLanguage = (language) => ({
  type: CHANGE_LANGUAGE,
  payload: language
});

export const fetchAddressDataAction = () => ({
  type: GET_ADDRESS_DATA_REQ
});

export const postNewAddressAction = (addressData) => ({
  type: POST_NEW_ADDRESS_REQ,
  payload: addressData
});

export const generateNewPOForParentAction = () => ({
  type: PO_INIT_REQ
});

export const getRequiredAddressTypeForCustomer = () => ({
  type: GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ
});

export const deleteAddressRequest = () => ({
  type: DELETE_ADDRESS_REQUEST
});

export const deleteAddressSuccess = (id) => ({
  type: DELETE_ADDRESS_SUCCESS,
  payload: id
});

export const deleteAddressFailure = (error) => ({
  type: DELETE_ADDRESS_FAILURE,
  payload: error
});

export const fetchProfileDetails = () => ({
  type: FETCH_PROFILE_DETAILS
});

export const fetchCustomerOffersAction = (currentOrgId) => ({
  type: GET_CUSTOMER_OFFERS_REQ,
  payload: currentOrgId
});

export const fetchAccessCard = (accessId, accessCode, orgId, clearOthers = false) => ({
  type: FETCH_ACCESS_CARD,
  payload: { accessId, accessCode, orgId, clearOthers }
});

export const fetchOrgAlbums = () => ({
  type: FETCH_ORG_ALBUMS
});

export const fetchKidsName = (firstName, lastName) => ({
  type: UPDATE_KIDS_NAME,
  payload: { firstName, lastName }
});

export const updateOrgIdForAccessCardAction = (orgId) => ({
  type: UPDATE_ORG_ID_FOR_ACCESS_CARD,
  payload: orgId
});

export const postEventOrderMetaUpdateAction = (payload) => ({
  type: POST_EVENT_ORDER_META_UPDATE_REQ,
  payload: payload,
});

export const fetchCart = (cartId) => ({
  type: FETCH_CART,
  payload: cartId
});

export const postCart = (cartData) => ({
  type: POST_CART,
  payload: cartData
});

export const fetchHomeData = () => ({
  type: FETCH_HOME_DATA
});

export const getProductsDataForEvent = (eventData) => ({
  type: GET_PRODUCTS_DATA_FOR_EVENT_REQ,
  payload: eventData
});

export const removeAccessCard = (accessId, accessCode) => ({
  type: REMOVE_ACCESS_CARD_REQUEST,
  payload: { accessId, accessCode }
});

export const removeAccessCardsBulk = (accessUids) => ({
  type: REMOVE_ACCESS_CARDS_BULK_REQUEST,
  payload: { accessUids }
});

export const clearRemovalBlockedAccessIds = () => ({
  type: CLEAR_REMOVAL_BLOCKED_ACCESS_IDS
});

export const getOTPForAccessCard = (payload) => ({
  type: GET_OTP_FOR_ACCESS_CARD,
  payload: payload
});

export const verifyAccessCardOTP = (payload) => ({
  type: VERIFY_ACCESS_CARD_OTP,
  payload: payload
});

export const setOTPVerifiedStatus = (status) => ({
  type: SET_OTP_VERIFIED_STATUS,
  payload: status
});

export const setCurrentAccessCardStateAction = (stateData) => ({
  type: SET_CURRENT_ACCESS_CARD_STATE,
  payload: stateData
});

export const clearProducts = () => ({
  type: CLEAR_PRODUCTS
});

export const updateDataForCheckOutStepsAction = (data) => ({
  type: UPDATE_CHECKOUT_STEPS_DATA,
  payload: data
});

export const updateSelectedAddressAction = (payload) => ({
  type: UPDATE_SELECTED_CUSTOMER_ADDRESS,
  payload: payload
});

export const clearExistingPOAction = () => ({
  type: CLEAR_EXISTING_PO
});

export const updateBillingAddressFlagAction = (flag) => ({
  type: UPDATE_BILLING_ADDRESS_FLAG,
  payload: flag
});

export const fetchPayboxData = () => ({
  type: FETCH_PAYBOX_DATA,
});

export const chooseOfferToApplyAction = (payload) => ({
  type: CHOOSE_OFFER_TO_APPLY,
  payload: payload
});

export const applyOfferAction = (payload) => ({
  type: APPLY_OFFER_TO_CART_REQ,
  payload: payload
});

export const getPaymentResultAction = (payload) => ({
  type: GET_PAYMENT_RESULT,
  payload: payload
});

export const getPaymentResultSuccess = (payload) => ({
  type: GET_PAYMENT_RESULT_SUCCESS,
  payload: payload
});

export const getPaymentResultFailure = (payload) => ({
  type: GET_PAYMENT_RESULT_FAILURE,
  payload: payload
});

export const getCustomerPurchaseOrdersAction = () => ({
  type: GET_CUSTOMER_PURCHASE_ORDERS_REQ
});

export const getCustomerPurchaseOrdersSuccess = (payload) => ({
  type: GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS,
  payload: payload
});

export const getCustomerPurchaseOrdersFailure = (error) => ({
  type: GET_CUSTOMER_PURCHASE_ORDERS_FAILURE,
  payload: error
});



export const downloadHDInOrderAction = (orderProductId) => ({
  type: DOWNLOAD_HD_IN_ORDER,
  payload: orderProductId
});

export const downloadHDInOrderSuccess = (payload) => ({
  type: DOWNLOAD_HD_IN_ORDER_SUCCESS,
  payload: payload
});

export const downloadHDInOrderFailure = (error) => ({
  type: DOWNLOAD_HD_IN_ORDER_FAILURE,
  payload: error
});

export const setCheckoutRefferer = () => ({
  type: SET_CHECKOUT_REFFERER,
});

export const clearCheckoutRefferer = () => ({
  type: CLEAR_CHECKOUT_REFFERER,
});

export const setCashPaymentDetails = (payload) => ({
  type: SET_CASH_PAYMENT_DETAILS,
  payload: payload
});

export const clearKidsName = () => ({
  type: CLEAR_KIDS_NAMES,

});

export const setResetPasswordDataAction = (payload) => ({
  type: SET_RESET_PASSWORD_DATA,
  payload: payload
});

export const postPOAddressAction = (payload) => ({
  type: POST_PO_ADDRESS_REQ,
  payload: payload
});

export const getPOAddressAction = (payload) => ({
  type: GET_PO_ADDRESS_REQ,
  payload: payload
});

export const setShippingSameAsBillingAction = (flag) => ({
  type: SET_SHIPPING_SAME_AS_BILLING,
  payload: flag
});